import { useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { RootState } from '@/store/index';
import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';
import InitialAvatar from "@/components/video/videoComments/avtar"
import CommentBox1 from "@/components/video/videoComments/commentBox1"
import RenderAnchorHtmlOrStr from "@/components/common/renderAnchorHtmlOrStr/renderAnchorHtmlOrStr"
import { typesOfComments } from "@/components/video/videoComments/main/constants"
import { handleCommentLikeDislikeApiCall, handleReplyLikeDislikeApiCall } from "@/utils/apiUtils"

import GreyDislikeUnfilled from "@/assets/icons/greyDislikeUnfilled.png";
import GreyDislikeFilled from "@/assets/icons/greyDislikeFilled.png";
import GreyLikeUnfilled from "@/assets/icons/greyLikeUnFilled.png";
import GreyLikeFilled from "@/assets/icons/greyLikeFilled.png";
import BlueDropDown from "@/assets/icons/blueDropDown.png"
import "./style.css"
import { useAuthToken } from '@/hooks/useAppSelectors';

export default function CommentHolder(props: any) {
    const token = useAuthToken()
    const { commentDetails, typesOfCommentFromParent, videoDocId } = props
    const dispatch = useDispatch();

    const { common } = useLocalTranslation();
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);

    const [likeDislikeBtnLoading, setLikeDislikeBtnLoading] = useState(false)
    const [isReplyConVisible, setIsReplyConVisible] = useState(false)
    const [showReplies, setShowReplies] = useState(false);

    const handleLike = async () => {
        setLikeDislikeBtnLoading(true)
        let payload = null
        let typeOfLike = ""
        if (typesOfCommentFromParent === typesOfComments.replyToComment) {
            typeOfLike = "commentLike"
            payload = {
                commentId: commentDetails._id,
                videoDocId: commentDetails.videoDocId,
                action: "like"
            }
        } else {
            typeOfLike = "replyLike"
            payload = {
                commentId: commentDetails.commentId,
                videoDocId: videoDocId,
                replyId: commentDetails._id,
                action: "like"
            }
        }

        if (payload) {
            if (typeOfLike === "commentLike") {
                const commentLikeDislikeApiCallStatus = await handleCommentLikeDislikeApiCall(payload, dispatch)
                // console.log(commentLikeDislikeApiCallStatus)
            } else {
                const replyLikeDislikeApiCallStatus = await handleReplyLikeDislikeApiCall(payload, dispatch)
            }
        }
        setLikeDislikeBtnLoading(false)
    }

    const handleDislike = async () => {
        setLikeDislikeBtnLoading(true)
        let payload = null
        let typeOfDislike = ""
        if (typesOfCommentFromParent === typesOfComments.replyToComment) {
            typeOfDislike = "commentDislike"
            payload = {
                commentId: commentDetails._id,
                videoDocId: commentDetails.videoDocId,
                action: "dislike"
            }
        } else {
            typeOfDislike = "replyDislike"
            payload = {
                commentId: commentDetails.commentId,
                videoDocId: videoDocId,
                replyId: commentDetails._id,
                action: "dislike"
            }
        }

        if (payload) {
            if (typeOfDislike === "commentDislike") {
                const commentLikeDislikeApiCallStatus = await handleCommentLikeDislikeApiCall(payload, dispatch)
                // console.log(commentLikeDislikeApiCallStatus)
            } else {
                const replyLikeDislikeApiCallStatus = await handleReplyLikeDislikeApiCall(payload, dispatch)
            }
        }
        setLikeDislikeBtnLoading(false)
    }

    const handleReply = () => {
        if (!isReplyConVisible) {
            setIsReplyConVisible(true)
        }
    }

    const cancleOfParent = () => {
        setIsReplyConVisible(false)
    }

    return (
        <div
            className="commentHolder">

            <div className='commentHolder01'>
                <InitialAvatar
                    name={commentDetails.username}
                />
                <p className='commetText'>
                    {commentDetails.username}
                    <span className='commentTime'>{moment(commentDetails.createdAt).fromNow()}</span>
                </p>
            </div>



            <div className='commentHolder01'>
                {/* {typesOfCommentFromParent === typesOfComments.replyToComment && */}
                <InitialAvatar
                    name={commentDetails.username}
                    isHidden={true}
                />
                {/* } */}

                <div className='commentHolder01Rhs'>
                    <div className='commetText01'>
                        {/* Either this component is coming for replyToComment OR replyToReply */}
                        <RenderAnchorHtmlOrStr
                            content={typesOfCommentFromParent === typesOfComments.replyToComment
                                ? commentDetails.comment : commentDetails.reply}
                        />
                    </div>


                    {token &&
                        <div className='likeDisLikeCon'>
                            {/* START : Like code */}
                            <button
                                onClick={handleLike}
                                disabled={likeDislikeBtnLoading}
                                style={{
                                    cursor: likeDislikeBtnLoading ? 'not-allowed' : 'pointer',
                                    opacity: likeDislikeBtnLoading ? 0.5 : 1
                                }}
                            >
                                <img
                                    className='likeIcon'
                                    src={commentDetails.isLiked ? GreyLikeFilled : GreyLikeUnfilled}
                                    alt='likeIcon' />
                            </button>
                            {/* END : Like code */}


                            {/* START : Like code */}
                            <button
                                onClick={handleDislike}
                                disabled={likeDislikeBtnLoading}
                                style={{
                                    cursor: likeDislikeBtnLoading ? 'not-allowed' : 'pointer',
                                    opacity: likeDislikeBtnLoading ? 0.5 : 1
                                }}
                            >
                                <img
                                    className='dislikeIcon'
                                    src={commentDetails.isDisliked ? GreyDislikeFilled : GreyDislikeUnfilled}
                                    alt='dislikeIcon' />
                            </button>
                            {/* END : Like code */}

                            <button
                                onClick={handleReply}
                                className='replyBtn'>
                                {common.statusText.replyBtn}
                            </button>
                        </div>
                    }


                    {/* START : Reply to reply con */}
                    {isReplyConVisible &&
                        <div className={`mt-[15px] 
                            ${typesOfCommentFromParent === typesOfComments.replyToReply ? 'ml-[-49px]' : ''}`}>
                            <CommentBox1
                                username={profileDetails.username}
                                typeOfComment={typesOfCommentFromParent}
                                cancleOfParent={cancleOfParent}
                                commentDetails={commentDetails}
                            />
                        </div>
                    }
                    {/* END : Reply to reply con */}



                    {/* START : Reply to replies con */}
                    {commentDetails.replies && commentDetails.replies.length > 0 &&
                        <div
                            key={commentDetails.replies._id}
                            className="repliesAccodianCon"
                            onClick={() => setShowReplies(!showReplies)}
                        >

                            {commentDetails.replies.length}{' '}
                            {common.statusText.replies}
                            <img
                                className={`${showReplies ? "rotate-180" : ""}`}
                                src={BlueDropDown}
                                alt='BlueDropDown' />
                        </div>
                    }


                    {showReplies && commentDetails.replies.map((reply: any, index: number) =>
                        reply.isVisible ? (
                            <div key={index}>
                                <CommentHolder
                                    commentDetails={reply}
                                    typesOfCommentFromParent={typesOfComments.replyToReply}
                                    videoDocId={commentDetails.videoDocId}
                                />
                            </div>
                        ) : null
                    )}
                    {/* END : Reply to replies con */}


                </div>
            </div>
        </div>
    );
}
